import { render, staticRenderFns } from "./TaxVerification.vue?vue&type=template&id=6a69df9a&scoped=true"
import script from "./TaxVerification.vue?vue&type=script&lang=js"
export * from "./TaxVerification.vue?vue&type=script&lang=js"
import style0 from "./TaxVerification.vue?vue&type=style&index=0&id=6a69df9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69df9a",
  null
  
)

export default component.exports